import React from 'react';
import { useVacationMode } from 'hooks/useVacationMode';
import { vacationUntilPhrase } from 'utils/vacation';
import './VacationBanner.css';

/**
 * App-wide banner while Vacation Mode is on. Rendered by the main layout above
 * page content on every authenticated page. Not dismissible: the way to clear
 * it is "I'm back", which turns Vacation Mode off at once.
 */
const VacationBanner: React.FC = () => {
  const vacation = useVacationMode();
  if (!vacation.active) return null;

  return (
    <div className="vacation-banner" role="status" data-testid="vacation-banner">
      <span className="vacation-banner__dot" aria-hidden="true" />
      <div className="vacation-banner__text">
        <div className="vacation-banner__title">Vacation Mode is on {vacationUntilPhrase(vacation.until)}</div>
        <div className="vacation-banner__sub">
          New sends, trade offers, and SMS alerts are paused. Trades already in progress continue as normal.
        </div>
      </div>
      <button
        type="button"
        className="vacation-banner__back"
        onClick={vacation.turnOff}
        disabled={vacation.isSaving}
        data-testid="vacation-banner-back"
      >
        I'm back
      </button>
    </div>
  );
};

export default VacationBanner;
